angular.module 'zc.projects'

.config ($stateProvider) ->

  $stateProvider
  .state 'admin.projects.settings',
    url: '/settings'
    controller: 'SettingsCtrl'
    views:
      'mainnav@':
        templateUrl: '/templates/core/views/mainnav.html'
        controller: 'MainnavCtrl'
      'content@':
        templateUrl: '/templates/projects.settings/index.html'
        controller: 'SettingsCtrl'
      'menu@admin.projects.settings':
        templateUrl: '/templates/projects.settings/menu.html'
        controller: 'MenuController'
        controllerAs: '$ctrl'
    resolve:
      excludeIps: (ProjectExcludeIp, $stateParams) ->
        ProjectExcludeIp.all($stateParams.projectId)
      contractStatuses: (Meta) ->
        Meta.getContractStatuses()
      invoiceCalculationTypes: (Meta) ->
        Meta.getInvoiceCalculationTypes()
      paymentMethods: (Meta) ->
        Meta.getPaymentMethods()
      invoiceIssueDays: (Meta) ->
        Meta.getInvoiceIssueDays()
      invoiceDueDays: (Meta) ->
        Meta.getInvoiceDueDays()
      invoicePaymentDays: (Meta) ->
        Meta.getInvoicePaymentDays()
      invoicePaymentMonths: (Meta) ->
        Meta.getInvoicePaymentMonths()
      trialInvoiceCalculationTypes: (Meta) ->
        Meta.getTrialInvoiceCalculationTypes()
      sessionCountEvaluators: (Meta) ->
        Meta.getSessionCountEvaluators()
      domainLinkTypes: (Meta) ->
        Meta.getProjectDomainLinkTypes()
      projectRanks: (Meta) ->
        Meta.getProjectRanks()
      productLines: (Meta) ->
        Meta.getProductLines()
      pricingTypes: (Meta) ->
        Meta.getPricingTypes()
      currencies: (Meta) ->
        Meta.getCurrencies()
      regions: (Meta) ->
        Meta.getRegions()
      optTargets: (Meta) ->
        Meta.getOptTargets()
      ip: (Ip) ->
        Ip.get()
      noPublishPageTypes: (PageType, $stateParams) ->
        PageType.all($stateParams.projectId).then (noPublishPageTypes) ->
          _.filter(noPublishPageTypes, { page_type: 'no_publish' })
      masterUsers: (Apollo) ->
        Apollo.masterQuery(
          gql('{
            users(role: master) {
              data {
                id
                email
              }
            }
          }')).then (res) ->
              return unless res

              _.flatten(
                [
                  { id: null, email: '--' },
                  _.map(_.sortBy(res.users.data, 'email'), (user) -> { id: Number(user.id), email: user.email })
                ]
              )

  .state 'admin.projects.settings.billing',
    url: '/billing'
    resolve:
      redirectNewDashboard: (Project, Devise, $stateParams, $window) ->
        redirectNewDashboard({ path: 'general/invoice', internalOnly: true }, Project, Devise, $stateParams, $window)
    views:
      'submenu@admin.projects.settings':
        templateUrl: '/templates/projects.settings/billing/submenu.html'
        controller: 'SettingsCtrl'
      'content@admin.projects.settings':
        templateUrl: '/templates/projects.settings/billing/index.html'

  .state 'admin.projects.settings.billing.billing_information',
    url: '/information'
    views:
      'submenu@admin.projects.settings':
        templateUrl: '/templates/projects.settings/billing/submenu.html'
        controller: 'SettingsCtrl'
      'content@admin.projects.settings':
        templateUrl: '/templates/projects.settings/billing/billing_information.html'

  .state 'admin.projects.settings.billing.representative_information',
    url: '/representatives'
    views:
      'submenu@admin.projects.settings':
        templateUrl: '/templates/projects.settings/billing/submenu.html'
        controller: 'SettingsCtrl'
      'content@admin.projects.settings':
        templateUrl: '/templates/projects.settings/billing/billing_representatives.html'

  .state 'admin.projects.settings.billing.zc_information',
    url: '/settings'
    views:
      'submenu@admin.projects.settings':
        templateUrl: '/templates/projects.settings/billing/submenu.html'
        controller: 'SettingsCtrl'
      'content@admin.projects.settings':
        templateUrl: '/templates/projects.settings/billing/zc_information.html'

  .state 'admin.projects.settings.billing.lens_information',
    url: '/lens_information'
    views:
      'submenu@admin.projects.settings':
        templateUrl: '/templates/projects.settings/billing/submenu.html'
        controller: 'SettingsCtrl'
      'content@admin.projects.settings':
        templateUrl: '/templates/projects.settings/billing/lens_information.html'

  .state 'admin.projects.settings.billing.iw_information',
    url: '/iw_information'
    views:
      'submenu@admin.projects.settings':
        templateUrl: '/templates/projects.settings/billing/submenu.html'
        controller: 'SettingsCtrl'
      'content@admin.projects.settings':
        templateUrl: '/templates/projects.settings/billing/iw_information.html'

  .state 'admin.projects.settings.billing.invoice_information',
    url: '/invoice_information'
    views:
      'submenu@admin.projects.settings':
        templateUrl: '/templates/projects.settings/billing/submenu.html'
        controller: 'SettingsCtrl'
      'content@admin.projects.settings':
        templateUrl: '/templates/projects.settings/billing/invoice_information.html'

  .state 'admin.projects.settings.installation',
    url: '/installation'
    views:
      'submenu@admin.projects.settings':
        templateUrl: '/templates/projects.settings/installation/submenu.html'
        controller: 'SettingsCtrl'
      'content@admin.projects.settings':
        templateUrl: '/templates/projects.settings/installation/index.html'

  .state 'admin.projects.settings.installation.tracking_tag',
    url: '/tracking_tag'
    resolve:
      redirectNewDashboard: (Project, Devise, $stateParams, $window) ->
        redirectNewDashboard({ path: 'setup', internalOnly: true }, Project, Devise, $stateParams, $window)
    views:
      'content@admin.projects.settings':
        templateUrl: '/templates/projects.settings/installation/tracking_tag.html'
        controller: 'TrackingTagCtrl'

  .state 'admin.projects.settings.installation.conversion_tag',
    url: '/conversion_tag'
    resolve:
      redirectNewDashboard: (Project, Devise, $stateParams, $window) ->
        redirectNewDashboard({ path: 'setup', internalOnly: true }, Project, Devise, $stateParams, $window)
    views:
      'content@admin.projects.settings':
        templateUrl: '/templates/projects.settings/installation/conversion_tag.html'
        controller: 'ConversionTagCtrl'

  .state 'admin.projects.settings.installation.conversion_url',
    url: '/conversion_url'
    views:
      'content@admin.projects.settings':
        templateUrl: '/templates/projects.settings/installation/conversion_url.html'

  .state 'admin.projects.settings.installation.test_conversion',
    url: '/test_conversion'
    views:
      'content@admin.projects.settings':
        templateUrl: '/templates/projects.settings/installation/test_conversion.html'

  .state 'admin.projects.settings.installation.exclude_ip',
    url: '/exclude_ip'
    views:
      'content@admin.projects.settings':
        templateUrl: '/templates/projects.settings/installation/exclude_ip.html'

  .state 'admin.projects.settings.installation.domain',
    url: '/domain'
    views:
      'content@admin.projects.settings':
        templateUrl: '/templates/projects.settings/installation/domain.html'

  .state 'admin.projects.settings.installation.login_evaluator_memo',
    url: '/login_evaluator_memo'
    views:
      'content@admin.projects.settings':
        templateUrl: '/templates/projects.settings/installation/login_evaluator_memo.html'

  .state 'admin.projects.settings.installation.newsletter_parameter_memo',
    url: '/newsletter_parameter_memo'
    views:
      'content@admin.projects.settings':
        templateUrl: '/templates/projects.settings/installation/newsletter_parameter_memo.html'

  .state 'admin.projects.settings.users',
    url: '/users'
    # NOTE: EMIN-6299 temporally enable user management features until migration to new dashboard
    # resolve:
    #   redirectNewDashboard: (Project, Devise, $stateParams, $window) ->
    #     redirectNewDashboard({ path: 'general/users', internalOnly: true }, Project, Devise, $stateParams, $window)
    views:
      'submenu@admin.projects.settings':
        templateUrl: '/templates/projects.settings/users/submenu.html'
      'content@admin.projects.settings':
        templateUrl: '/templates/projects.settings/users/index.html'
        controller: 'UserIndexCtrl'

  .state 'admin.projects.settings.users.invite',
    url: '/invite'
    # NOTE: EMIN-6299 temporally enable user management features until migration to new dashboard
    # resolve:
    #   redirectNewDashboard: (Project, Devise, $stateParams, $window) ->
    #     redirectNewDashboard({ path: 'general/users', internalOnly: true }, Project, Devise, $stateParams, $window)
    views:
      'content@admin.projects.settings':
        templateUrl: '/templates/projects.settings/users/invite.html'
        controller: 'UserInviteCtrl'

  .state 'admin.projects.settings.basic',
    url: '/basic'
    views:
      'submenu@admin.projects.settings':
        templateUrl: '/templates/projects.settings/basic/submenu.html'
      'content@admin.projects.settings':
        templateUrl: '/templates/projects.settings/basic/index.html'

  .state 'admin.projects.settings.basic.basic',
    url: '/basic'
    views:
      'content@admin.projects.settings':
        templateUrl: '/templates/projects.settings/basic/basic.html'

  .state 'admin.projects.settings.basic.sales_management',
    url: '/sales_management'
    resolve:
      redirectNewDashboard: (Project, Devise, $stateParams, $window) ->
        redirectNewDashboard({ path: 'general/site', internalOnly: true }, Project, Devise, $stateParams, $window)
    views:
      'content@admin.projects.settings':
        templateUrl: '/templates/projects.settings/basic/sales_management.html'

  .state 'admin.projects.settings.basic.project_status',
    url: '/project_status'
    resolve:
      redirectNewDashboard: (Project, Devise, $stateParams, $window) ->
        redirectNewDashboard({ path: 'general/site', internalOnly: true }, Project, Devise, $stateParams, $window)
    views:
      'content@admin.projects.settings':
        templateUrl: '/templates/projects.settings/basic/project_status.html'

  .state 'admin.projects.settings.basic.control_percent',
    url: '/control_percent'
    resolve:
      redirectNewDashboard: (Project, Devise, $stateParams, $window) ->
        redirectNewDashboard({ path: 'general/site', internalOnly: true }, Project, Devise, $stateParams, $window)
    views:
      'content@admin.projects.settings':
        templateUrl: '/templates/projects.settings/basic/control_percent.html'

  .state 'admin.projects.settings.basic.remove_apikey',
    url: '/remove_apikey'
    views:
      'content@admin.projects.settings':
        templateUrl: '/templates/projects.settings/basic/remove_apikey.html'



  .state 'admin.projects.settings.campaign',
    url: '/campaign'
    views:
      'submenu@admin.projects.settings':
        templateUrl: '/templates/projects.settings/campaign/submenu.html'
      'content@admin.projects.settings':
        templateUrl: '/templates/projects.settings/campaign/no_publish_page_type.html'

  .state 'admin.projects.settings.campaign.timing',
    url: '/timing'
    views:
      'content@admin.projects.settings':
        templateUrl: '/templates/projects.settings/campaign/timing.html'

  .state 'admin.projects.settings.campaign.advertising',
    url: '/advertising'
    resolve:
      redirectNewDashboard: (Project, Devise, $stateParams, $window) ->
        redirectNewDashboard({ path: 'general/campaign', internalOnly: true }, Project, Devise, $stateParams, $window)
    views:
      'content@admin.projects.settings':
        templateUrl: '/templates/projects.settings/campaign/advertising.html'

  .state 'admin.projects.settings.campaign.newsletter',
    url: '/newsletter'
    resolve:
      redirectNewDashboard: (Project, Devise, $stateParams, $window) ->
        redirectNewDashboard({ path: 'general/campaign', internalOnly: true }, Project, Devise, $stateParams, $window)
    views:
      'content@admin.projects.settings':
        templateUrl: '/templates/projects.settings/campaign/newsletter.html'

  .state 'admin.projects.settings.campaign.segment_cookie',
    url: '/segment_cookie'
    resolve:
      redirectNewDashboard: (Project, Devise, $stateParams, $window) ->
        redirectNewDashboard({ path: 'general/campaign', internalOnly: true }, Project, Devise, $stateParams, $window)
    views:
      'content@admin.projects.settings':
        templateUrl: '/templates/projects.settings/campaign/segment_cookie.html'

  .state 'admin.projects.settings.campaign.dm_upload',
    url: '/dm_upload'
    views:
      'content@admin.projects.settings':
        templateUrl: '/templates/projects.settings/campaign/dm_upload.html'
        controller: 'DetailProjectCtrl'
        resolve:
          visitorIdsForDM: (Project, $stateParams) ->
            Project.getVisitorIdsForDM(projectId: $stateParams.projectId)



  .state 'admin.projects.settings.other',
    url: '/other'
    resolve:
      redirectNewDashboard: (Project, Devise, $stateParams, $window) ->
        redirectNewDashboard({ path: 'general/other', internalOnly: true }, Project, Devise, $stateParams, $window)
    views:
      'submenu@admin.projects.settings':
        templateUrl: '/templates/projects.settings/other/submenu.html'
      'content@admin.projects.settings':
        templateUrl: '/templates/projects.settings/other/index.html'

  .state 'admin.projects.settings.other.publish_domain',
    url: '/publish_domain'
    views:
      'content@admin.projects.settings':
        templateUrl: '/templates/projects.settings/other/publish_domain.html'

  .state 'admin.projects.settings.other.data_management',
    url: '/data_management'
    views:
      'content@admin.projects.settings':
        templateUrl: '/templates/projects.settings/other/data_management.html'

  .state 'admin.projects.settings.other.particular_event',
    url: '/particular_event'
    views:
      'content@admin.projects.settings':
        templateUrl: '/templates/projects.settings/other/particular_event.html'

  .state 'admin.projects.settings.other.breadcrumb_selector',
    url: '/breadcrumb_selector'
    views:
      'content@admin.projects.settings':
        templateUrl: '/templates/projects.settings/other/breadcrumb.html'


  .state 'admin.projects.settings.other.zcs',
    url: '/zcs'
    views:
      'content@admin.projects.settings':
        templateUrl: '/templates/projects.settings/other/zcs.html'

  .state 'admin.projects.settings.other.iw',
    url: '/iw'
    views:
      'content@admin.projects.settings':
        templateUrl: '/templates/projects.settings/other/iw.html'

  .state 'admin.projects.settings.other.app',
    url: '/app'
    views:
      'content@admin.projects.settings':
        templateUrl: '/templates/projects.settings/other/app.html'


  .state 'admin.projects.settings.initialization',
    url: '/initialization'
    resolve:
      redirectNewDashboard: (Project, Devise, $stateParams, $window) ->
        redirectNewDashboard({ path: 'setup', internalOnly: true }, Project, Devise, $stateParams, $window)
    views:
      'submenu@admin.projects.settings':
        templateUrl: '/templates/projects.settings/initialization/submenu.html'
      'content@admin.projects.settings':
        templateUrl: '/templates/projects.settings/initialization/index.html'

  .state 'admin.projects.settings.initialization.session_count_evaluator',
    url: '/session_count_evaluator'
    views:
      'content@admin.projects.settings':
        templateUrl: '/templates/projects.settings/initialization/session_count_evaluator.html'

  .state 'admin.projects.settings.initialization.page_type',
    url: '/page_type'
    views:
      'content@admin.projects.settings':
        templateUrl: '/templates/projects.settings/initialization/page_type.html'

  .state 'admin.projects.settings.initialization.untrack_page_type',
    url: '/untrack_page_type'
    views:
      'content@admin.projects.settings':
        template: '<zc-untrack-page-types project="project"></zc-untrack-page-types>'
        controller: ($scope, currentProject) ->
          $scope.project = currentProject
          return

  .state 'admin.projects.settings.initialization.exclude_ip',
    url: '/exclude_ip'
    views:
      'content@admin.projects.settings':
        templateUrl: '/templates/projects.settings/initialization/exclude_ip.html'

  .state 'admin.projects.settings.initialization.cross_domain',
    url: '/cross_domain'
    views:
      'content@admin.projects.settings':
        templateUrl: '/templates/projects.settings/initialization/cross_domain.html'

  .state 'admin.projects.settings.initialization.ga_tag_tracking',
    url: '/ga_tag_tracking'
    views:
      'content@admin.projects.settings':
        templateUrl: '/templates/projects.settings/initialization/ga_tag_tracking.html'
        controller: 'GaTagTrackingCtrl'
        resolve:
          currentProject: (currentProject) ->
            currentProject
          googleAnalyticsEventLabels: (Meta) ->
            Meta.getGoogleAnalyticsEventLabels()

  .state 'admin.projects.settings.initialization.cart_button',
    url: '/cart_button'
    views:
      'content@admin.projects.settings':
        templateUrl: '/templates/projects.settings/initialization/cart_button.html'

  .state 'admin.projects.settings.initialization.login_evaluator',
    url: '/login_evaluator'
    views:
      'content@admin.projects.settings':
        templateUrl: '/templates/projects.settings/initialization/login_evaluator.html'

  .state 'admin.projects.settings.initialization.item_price',
    url: '/item_price'
    views:
      'content@admin.projects.settings':
        templateUrl: '/templates/projects.settings/initialization/item_price.html'

  .state 'admin.projects.settings.initialization.item_list_price',
    url: '/item_list_price'
    views:
      'content@admin.projects.settings':
        templateUrl: '/templates/projects.settings/initialization/item_list_price.html'

  .state 'admin.projects.settings.initialization.cart_price',
    url: '/cart_price'
    views:
      'content@admin.projects.settings':
        templateUrl: '/templates/projects.settings/initialization/cart_price.html'

  .state 'admin.projects.settings.initialization.distinguish_direct_indirect_cv',
    url: '/distinguish_direct_indirect_cv'
    views:
      'content@admin.projects.settings':
        templateUrl: '/templates/projects.settings/initialization/distinguish_direct_indirect_cv.html'

  .state 'admin.projects.settings.initialization.cookie_server_setting',
    url: '/cookie_server_setting'
    views:
      'content@admin.projects.settings':
        templateUrl: '/templates/projects.settings/initialization/cookie_server_setting.html'

redirectNewDashboard = (params, Project, Devise, $stateParams, $window) ->
  if params.internalOnly and !Devise.isCommonUser()
    Project.getCurrent($stateParams.projectId)
      .then (project) ->
        $window.location.href = "#{ZC_CONFIG.AIDEAL_URL}/site/#{project.apikey}/settings/#{params.path}"



// WEBPACK FOOTER //
// ./src/zenclerk_modules/projects.settings/routes.coffee